import React, { createRef, useRef, useEffect, useState, useLayoutEffect } from 'react';
import useContainerDimensions from '../helpers/useContainerDimensions';
import DigitalMenuHeader from './DigitalMenuHeader';
import withAppState from '../mobx/withAppState';
import filterIcon from '../assets/img/filter-icon.svg';
import mapmarkerWireframe from '../assets/img/mapmarker-wireframe.png';
import makeCancelable from '../helpers/PromiseWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faStar
} from '@fortawesome/free-solid-svg-icons';
import CloseIconRose from '../assets/img/closeIconRose.svg';
import GeoLocationRose from '../assets/img/geoLocationRose.svg';
import { Fragment } from 'react';
import dataLayer from '../lib/dataLayer';

const {dataLayerAttribute} = dataLayer; 
const {addToDataLayerList} = dataLayer;

const NavButton = (props) => {
  const { selected, children } = props;
  return (
    <div onClick={props.onClick} className={`nav-menu-button ${selected ? 'selected' : ''}`}>
      {children}
    </div>
  )
}

const MenuList = props => {
  const { list, scrollItemIndex } = props;
  return list.map((item, index) => {
      const { name } = item;
      if (!item.ref) item.ref = createRef(); 
      if (!item.navRef) item.navRef = createRef();
      if (!item.titleRef) item.titleRef = createRef();
      return (
          <div
              ref={item.navRef}
              key={`menu-list-item-${index}`}
              className={`scrolling-menu-button ${scrollItemIndex === index ? 'selected' : ''} ${item.headerStyle}`}
              onClick={() => {
                  item.ref.current.scrollIntoView({
                      block: 'start',
                      inline: 'start',
                  });
              }}>
              <p>{name.toLowerCase()}</p>
          </div>
      );
  });
};

const getProgressFromTo = (from, to, animationDecimal) => {
  return from + (to - from) * animationDecimal;
}

const NavMenu = props => {
  const insetsTop = parseInt(new URLSearchParams(window.location.search).get('insets.top') || '0');
  const navCTA = useRef([]);
  const spacingDiv = createRef();
    const [currentPositionPercent, setCurrentPositionPercent] = useState(0);
  const { 
    rootCategories, 
    menuBanner, 
    selectedIndex, 
    setIndex, 
    displaySubcategories, 
    scrollItemIndex, 
    scrollContainer, 
    scrollWrapper, 
    dietaryFilterCta,
    dietaryFilter,
    navMenuContainer,
    navMenuWrapper,
    setDigitalMenuOffset,
    digitalMenuOffsetHeight,
    menuPage
  } = props;
    const [results, setResults] = useState(props.restaurantSearchCache);
    const [displayingNearby, setDisplayingNearby] = useState(false);
    //const [isRestaurantUrl, setRestaurantUrl] = useState('');
    const [nearbyResults, setNearbyResults] = useState({});
    const [searchString, setSearchString] = useState('');
    const [loading, setLoading] = useState(false);
    const [searching, setSearching] = useState(false);
    //const [locationModalShow, setLocationModalShow] = useState(false);
    const [resultMessage, setResultMessage] = useState('');
    // const [favRest, setFavRest] = useState(
    //     (props.customer && props.customer.favouriteRestaurants) || null
    // );
    const [isResultCardVisible, setIsResultCardVisible] = useState(false);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [showRestaurantSearchPopup, setShowRestaurantSearchPopup] = useState(false);
    const [inputValue ,setInputValue] = useState('');
    let timer = null;
    let requests = [];
    let locationRequests = [];
    let loadingTimeout = null;
    const restaurantSearchPopup = showRestaurantSearchPopup ? 'overlay active showing' : "overlay";
    const mapmarker = <img src={mapmarkerWireframe} />;

    const WAIT_INTERVAL = 500;
    const LOADING_TIMEOUT_SECONDS = 7;
    const filledRootCategories = rootCategories.filter(mc => mc.menuCategories.length !== 0);

    const tabs = filledRootCategories
        ? filledRootCategories.map(menuCategory => {
    const menuCategoryClass = (menuCategory?.name?.split(' ')[0]?.toLowerCase()) || '';

    const categoryPreferredName = (name) => {
      var preferredName = "";
      if(name === "Pizzeria") {
          preferredName = "Pizza";
      } else {
          preferredName = name;
      }
      return preferredName;
    }

    return (
        <div ref={menuCategory => (navCTA.current = [...navCTA.current, menuCategory])} className={`nav-button ${menuCategoryClass}`}>
          <p>{categoryPreferredName(menuCategory.name)}</p>
        </div>
    )
  }
  ) : [];

  const [isOverflowing, setIsOverflowing] = useState(false);
  const widthNavMenuContainer = useContainerDimensions(navMenuContainer);
  const menuBannerHeight = useContainerDimensions(menuBanner);

  useEffect(() => {
    const handleScroll = event => {
        const scrollTop = menuPage.current.scrollTop;
        var body = document.body,
        html = document.documentElement;

        // //https://stackoverflow.com/a/1147768
        var documentHeight = Math.max( body?.scrollHeight, body?.offsetHeight, html?.clientHeight, html?.scrollHeight, html?.offsetHeight);
        // //  Element is fixed height, can't compare to body
        const scrollPercent = (scrollTop / (documentHeight)) * 100;

        const animationDecimal = scrollPercent / 100;
        const finishPositionPercent = 100;
        const startPositionPercent = 0;
        const currentPositionPercent = getProgressFromTo(startPositionPercent, finishPositionPercent, animationDecimal);

        // console.log({
        //     documentHeight,
        //     scrollPercent,
        //     animationDecimal,
        //     currentPositionPercent,
        //     scrollTop
        // });

        setCurrentPositionPercent(currentPositionPercent)

    };


      menuPage.current.addEventListener('scroll', () => {handleScroll()});

    return () => {

        if(menuPage !== null && menuPage.current !== null){
            menuPage.current.removeEventListener('scroll', () => {handleScroll()});
        }
    };
}, []);

  useEffect(() => {
    setDigitalMenuOffset(menuBannerHeight.height + 50);
});

    const divStyle = {
        backgroundColor: '#331a1f',
        height: '32px',
        marginTop: '-32px',
        top: '0px',
        width: '100%',
        position: 'absolute',
    };

  const getNavigationBarWidth = (navWrapper) => {
    let overFlowRightWidth = 0;
    if (navWrapper.current != null) {
      const lastChild = navWrapper.current.lastChild;
      overFlowRightWidth = lastChild.offsetLeft + lastChild.offsetWidth;
      if (overFlowRightWidth < widthNavMenuContainer.width) {
        return true;
      } else {
        return false;
      }
    }
  };
  
  useLayoutEffect(() => {
    setIsOverflowing(getNavigationBarWidth(navMenuWrapper) || getNavigationBarWidth(scrollContainer));
  }, [menuBannerHeight.width]);

    const selectedMenuCategory = filledRootCategories[selectedIndex];
    const selectedMenuCategoryList = !selectedMenuCategory || !selectedMenuCategory.menuCategories ? [] : selectedMenuCategory.menuCategories;

    const DietaryFilterIcon = props => {
        const { dietaryFilter } = props;
        var keys = Object.keys(dietaryFilter);
        var filtered = keys.filter(key => {
            return dietaryFilter[key];
        });
        return filtered.length > 0 ? <span className="filtered-value">{filtered.length}</span> : null;
    };

    useEffect(() => {
        return () => {
          for (let i = 0; i < requests.length; i++) {
            requests[i].cancel();
          }
          cancelLocationRequests();
        };
      }, []);

    function cancelLocationRequests() {
        for (let i = 0; i < locationRequests.length; i++) {
            locationRequests[i].cancel();
        }
    }

    async function handleSearchChange(event) {   
        var inputString = event.target.value;
        setInputValue(inputString); 
        clearTimeout(timer);
        timer = setTimeout(async () => {
            await triggerSearch();
            setIsResultCardVisible(inputString.trim() !== '');
        }, WAIT_INTERVAL);
    }

    // toggleLocationModal = () => {
    //     this.setState({ locationModalShow: !this.state.locationModalShow })
    // }

    async function triggerSearch() {
        let searchInput = document.getElementsByName('search-input')[0];

        if (!!searchInput) {
            const searchInputString = searchInput.value;            
            setSearchString(searchInputString);
            if (searchInputString.trim() !== '') {
                cancelLocationRequests();

                if (!loadingTimeout) {
                    loadingTimeout = setTimeout(() => {
                        setLoading(true);
                    }, LOADING_TIMEOUT_SECONDS * 1000);
                }

                var request = makeCancelable(
                    fetch('api/Restaurant/LookupName/' + searchInputString)
                );
                setSearching(true);
                requests.push(request);
                let response = await request;
                if (response.status === 200) {
                    return response
                        .json()
                        .catch(err => {
                            loadingTimeout = clearTimeout(loadingTimeout);
                            setLoading(false);
                            setSearching(false);
                        })
                        .then(data => {
                            loadingTimeout = clearTimeout(loadingTimeout);                            
                            setDisplayingNearby(false);
                            setResults(data);
                            setLoading(false);
                            setSearching(false);
                        });
                } else {
                    loadingTimeout = clearTimeout(loadingTimeout);
                    setLoading(false);
                    setSearching(false);
                }
            } else {                
                setDisplayingNearby(true);
            }
        }

        
    }

    function getLocation() {
        navigator.geolocation.getCurrentPosition(
            position => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                if (!loadingTimeout) {
                    loadingTimeout = setTimeout(() => {
                        setLoading(true);
                    }, LOADING_TIMEOUT_SECONDS * 1000);
                }
                setSearching(true);
                let request = makeCancelable(
                    fetch(`api/Restaurant/LookupLatLong/${lat}/${lng}`)
                );
                locationRequests.push(request);
                request
                    .then(response => {
                        if (response.status === 200) {
                            response.json().then(data => {
                                loadingTimeout = clearTimeout(loadingTimeout);                                
                                setNearbyResults(data);
                                setDisplayingNearby(true);
                                setLoading(false);
                                setSearching(false);
                            });
                        } else {
                            loadingTimeout = clearTimeout(loadingTimeout);                            
                            setLoading(false);
                            setSearching(false);
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        loadingTimeout = clearTimeout(loadingTimeout);                        
                        setLoading(false);
                        setSearching(false);
                    });
            },
            error => {
                setNearbyResults({});
                setDisplayingNearby(true);
                setLoading(false);
                setSearching(false);
                setResultMessage('Use my location');

                // console.log(error.code);
                // console.log(error.message);

                // error.code can be:
                //   0: unknown error
                //   1: permission denied
                //   2: position unavailable (error response from location provider)
                //   3: timed out
            }
        );
    }

    async function handleLocationSearch() {
        //  navigator.permissions is not supported on iOS

        if (navigator && navigator.permissions && navigator.permissions.query) {
            let permissionQuery = await navigator.permissions.query({
                name: 'geolocation'
            });
            var navigatorGeolocationState = permissionQuery.state;
            if (navigatorGeolocationState === 'prompt') {
                setResultMessage('Would you like to search for nearby restaurants?');
                getLocation();
            } else {
                getLocation();
            }
        } else {
            getLocation();
        }
    }

    function restaurantNameFromUrl(restaurant) {
        let resultUrl = '';

        if(!!restaurant?.restaurantUrlName)
        {
            resultUrl = restaurant.restaurantUrlName;
        } 

        props.setRestaurantUrl(resultUrl);        
    }

    function handleRestaurantClick(restaurant) {   
        
        var dataLayerArray = [];
    
        dataLayerArray.push(
          { [dataLayerAttribute.EVENT]: "restaurant_link_clicked_banner" },
          { [dataLayerAttribute.PAGE_TYPE]: "restaurant_link_clicked_banner" },
          { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
          { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
        );
    
        addToDataLayerList(dataLayerArray);
 
        
        closePopupDisplay();
        restaurantNameFromUrl(restaurant);
        props.cacheRestaurantSearch(results);
        props.handleRestaurantSelect(restaurant);        
        
        if (!!restaurant && !!restaurant.restaurantUrlName) {
            var pathArray = window.location.pathname.split("/").filter(p => p);
            
            if (pathArray.length == 2) {
                pathArray.unshift(restaurant.restaurantUrlName);
                window.history.replaceState(null, "", pathArray.join('/').toString());
            }

            if (pathArray.length == 3) {
                pathArray[0] = restaurant.restaurantUrlName;
                window.history.replaceState(null, "", pathArray.join('/').toString());
            }
        }
    }

    function displayResults() {
        let finalResults = displayingNearby
            ? nearbyResults
            : results;

        if (!!finalResults && !!finalResults.restaurants) {
            var restaurants = finalResults.restaurants;

            if (restaurants.length > 0) {
                var output = [];

                if (searching === true) {
                    output.push(
                        <div className="result-card header">
                            <div className="loading-text">
                                <div className={`lds-dual-ring main-loading`}></div>
                                <div className={`restaurant-address`}>
                                    {loading === true ? (<p className="search-loading">Sorry, we're taking longer than usual to process your search</p>
                                    ) : <p>Searching...</p>}
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    if (displayingNearby === true) {
                        output.push(
                            <div
                                key={'nearby'}
                                className="result-card header"
                            >
                                <div className="restaurant-address">Search Results</div>
                            </div>
                        );
                    } else {
                        output.push(
                            <div
                                key={'results'}
                                className="result-card header"
                            >
                                <div className="restaurant-address">Search results</div>
                            </div>
                        );
                    }
                }

                output.push(
                    restaurants.map((restaurant, index) => {
                        return (
                            <Fragment key={`${restaurant.name}-${index}`}>
                                {restaurantResult(restaurant, index)}
                            </Fragment>
                        );
                    })
                );

                return output;
            }
        }
        return null;
    }

    function displayFavourites() {
        if (
            !!props.customer &&
            !!props.customer.favouriteRestaurants
        ) {
            const favouriteRestaurants = props.customer.favouriteRestaurants;
            return (
                <div className="restaurant-favourites">
                    <div className="myPeFavourites">
                        <h3>My Favourites</h3>
                        {favouriteRestaurants.map((restaurant, index) => {
                            return restaurantResult(restaurant, index);
                        })}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    function restaurantResult(restaurant, index) {
        const { customer } = props;
        const starIcon = <FontAwesomeIcon icon={faStar} />;
        let star = null;
        if (customer) {
            const { favouriteRestaurants } = customer;
            const firstFavRestaurantId = (favouriteRestaurants && favouriteRestaurants.length > 0) ? favouriteRestaurants[0].id : null
            if (firstFavRestaurantId === restaurant.id) {
                star = <span className="fav-restaurant-star">{starIcon}</span>;
            }
        }


        let distance = null;
        if (!!restaurant.distance)
            distance = (Number(restaurant.distance) / 1000).toFixed(1) + 'km';
        return (
            <div
                key={index}
                className="result-card clickable restaurant-info p-6 txt-left is-flex is-flex-col bg-lighter-grey is-radius-4"
                onClick={() => handleRestaurantClick(restaurant)}
            >
                <div className="restaurant-name">
                    <h3>
                        {`${restaurant.name}`}
                    </h3>                                        
                </div>
                <div>
                    {!!distance && (
                        <span className="fav-restaurant-distance">
                            {mapmarker} <strong>{distance}</strong>
                        </span>
                    )}
                </div>

                {!!props.customer && !!props.customer.favouriteRestaurants && (
                    <div className="restaurant-icon">{!!star && star}</div>
                )}
                {!!restaurant.fullAddress && (
                    <div className="restaurant-address">{restaurant.fullAddress}</div>
                )}
            </div>
        );
    }

    const handleInputFocus = () => {
        setIsInputFocused(true);
    }

    const handleInputBlur = () => {
        setIsInputFocused(false);
    }

    const showPopupDisplay = () => {
        setShowRestaurantSearchPopup(true);
    }

    const closePopupDisplay = () => {
        setShowRestaurantSearchPopup(false);
        setInputValue('');
        setIsResultCardVisible(false);
    };

    const doGeolocation = () => {
        setIsResultCardVisible(false);
        setInputValue('');
        handleLocationSearch();
        setIsResultCardVisible(true);
    };
 
    return (
        <>
            <DigitalMenuHeader popUpDisplayHandler={showPopupDisplay} dietaryFilter={dietaryFilter} dietaryFilterCta={dietaryFilterCta}/>

            {/* Restaurant search popup section */}
            <section className={restaurantSearchPopup}>
                <div className="overlay-content-container fixed-top-scroll">
                    <div className="overlay-content-inner-container restaurant-overlay">
                        <button className="overlay-close overlay-close-restaurant" onClick={closePopupDisplay}><img src={CloseIconRose} alt="Close find restaurant overlay"/></button>
                        <div className="overlay-content overlay-header pb-22-i">
                            <h3 className="overlay-content-heading txt-center">SELECT A <br/> RESTAURANT</h3>
                            <div className="padding-bottom-large">
                                <div className="restaurant-search-container">
                                    <div className="restaurant-search-container">
                                        <div className="global-restaurant-search-container large-results flex">
                                                <div className={`preorder-search-select ${isInputFocused ? 'focused' : ''}`}>
                                                <input 
                                                    className="search-restaurant-input input is-col-12"
                                                    ref={input => input && input.focus()}
                                                    onBlur={handleInputBlur}
                                                    tabIndex="0"
                                                    type="text"
                                                    autoComplete="off"
                                                    name="search-input"
                                                    placeholder="Search location"
                                                    onChange={handleSearchChange}
                                                    value={inputValue}
                                                    />
                                                        <i className="fas fa-circle-notch"></i>
                                                </div>
                                                <div className="search-results-container IEfix is-col-12 btn-shadow txt-black">
                                                    <div className="search-results search-results-restaurants">
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    <div className="restaurant-search-geolocation-icon">
                                        <button className="btn-geolocation" onClick={() => doGeolocation()}>
                                            <img src={GeoLocationRose} alt="find your nearest restaurant"/>
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="full-width">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            (((!!inputValue || isResultCardVisible) && (!!displayResults() || !!resultMessage)) && (    
                            <div className="is-row justify-around"  style={{ display: isResultCardVisible ? 'block' : 'none' }}>
                                <div className="is-flex is-flex-col tabs-container full-width">
                                    <div className="tab active">                        
                                        <div className="transparent-tabs tabs-container find-order-book bg-light-grey is-radius-8-b">
                                            
                                            <div className="tab active">
                                                <div className="px-6 py-8">                                                           
                                                    <div className="result-card-container">
                                                        {displayResults() || (
                                                            <div className="no-results">
                                                                <div onClick={() => handleLocationSearch()}>
                                                                    {resultMessage}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {displayFavourites()}
                                                    </div>
                                                </div>
                                            </div>                                    
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )
                            )
                        }
                    </div>
                </div>
            </section>
            {/* Restaurant search popup section */}
            <div ref={menuBanner} className={`menu-banner ${selectedMenuCategoryList.length > 1 ? 'nav-menu' : ''}`} style={{ top: `${32 + parseInt(insetsTop)}px` }}>
                <div ref={navMenuContainer} className={`nav-menu scrolling-wrapper`}>
                    {dietaryFilterCta && dietaryFilter ? (
                        <div className="nav-button-container">
                            <button className="nav-filter-btn" onClick={dietaryFilterCta}>
                                <DietaryFilterIcon dietaryFilter={dietaryFilter} />
                                <span className="icon">
                                    <img src={filterIcon} alt="filter icon" />
                                </span>
                            </button>
                        </div>
                    ) : null}
                    <div className="nav-menu inner-wrapper">
                          <div ref={spacingDiv} style={
                            {
                                backgroundColor: 'var(--primary-malbec)',
                                visibility: currentPositionPercent > 35 ? 'visible' : 'hidden',
                                height: `${35 + insetsTop}px`,
                                top: '-1px',
                                width: '100%',
                                position: 'fixed'
                            }}>
                        </div>
                        
                        <div className={`nav-menu-inner`}>
                            <div ref={navMenuWrapper} className="menu-tabbed">
                                {tabs.map((element, index) => {
                                    const selected = selectedIndex === index;
                                    return (
                                        <>
                                            <NavButton key={`nav-button-${index}`} selected={selected} onClick={() => setIndex(index)}>
                                                {element}
                                            </NavButton>
                                        </>
                                    );
                                })}
                            </div>
                        </div>
                        {selectedMenuCategoryList.length > 1 ? (
                            <div className={`scrolling-menu-wrapper`}>
                                <nav ref={scrollWrapper} className="scrolling-menu-list">
                                    <div ref={scrollContainer} className="scrolling-menu-list-inner">
                                        <MenuList key={selectedIndex} list={selectedMenuCategoryList} scrollItemIndex={scrollItemIndex} />
                                    </div>
                                </nav>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div >
        </>
    );
};
export default withAppState(NavMenu, {
  mobXProps: ({ 
    activeStep,
    digitalMenuOffsetHeight,
    restaurantUrl
  }) => ({
    activeStep,
    digitalMenuOffsetHeight,
    restaurantUrl
  }),
    mobXActions: ({ setDigitalMenuOffset, cacheRestaurantSearch, setRestaurantUrl }) => ({        
        setDigitalMenuOffset,
        cacheRestaurantSearch,
        setRestaurantUrl
    }),
});
